var $4ef984f5ccc73733$exports = {};
$4ef984f5ccc73733$exports = {
    "valid": `Va\u{17E}e\u{107}e`
};


export {$4ef984f5ccc73733$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
